// SPDX-License-Identifier: LicenseRef-Proprietary
// Copyright (c) 2025 Mann Contractual Management Ltd

import base from "./tokens/base"
import colors from "./tokens/colors"
import space from "./tokens/space"
import sizes from "./tokens/sizes"
import fonts from "./tokens/fonts"
import fontSizes from "./tokens/font-sizes"
import fontWeights from "./tokens/font-weights"
import lineHeights from "./tokens/line-height-headings"
import borderWidths from "./tokens/border-widths"
import radii from "./tokens/radii"
import shadows from "./tokens/shadows"
import zIndices from "./tokens/z-indices"
import text from "./variants/text"
import buttons from "./variants/buttons"
import badges from "./variants/badges"
import links from "./variants/links"
import cards from "./variants/cards"
import images from "./variants/images"
import styles from "./styles"

const theme = {
  colors,
  space,
  sizes,
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
  borderWidths,
  radii,
  shadows,
  zIndices,
  text,
  buttons,
  badges,
  links,
  cards,
  images,
  styles,
}

export default theme
export { base as baseThemeSettings }
